export default "__VITE_ASSET__680a9321__"